import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../config/firebase';
import SSOButtons from './SSOButtons';
import { trackUserLogin, trackUserSignUp } from '../utils/analytics';
import './AnimatedBee.css';

const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
        trackUserLogin('email');
      } else {
        await createUserWithEmailAndPassword(auth, email, password);
        trackUserSignUp('email');
      }
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#ffffff',
      padding: '20px'
    }}>
      <div className="card" style={{
        width: '100%',
        maxWidth: '400px',
        padding: '40px'
      }}>
        <div className="login-bee-container">
          <h1>Professional Bee Management<br /><span>Beebase Pro</span></h1>
          <div className="bee">
            <div className="antennae"></div>
            <div className="wing one"></div>
            <div className="wing two"></div>
          </div>
          <div className="shadow"></div>
        </div>
        
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p style={{ color: '#2c3e50', margin: 0, fontSize: '14px', fontWeight: '500' }}>
            Manage your apiaries and hive inspections with professional tools
          </p>
        </div>
        
        <div>
          <h2 style={{ color: 'var(--bee-black)', marginBottom: '20px', textAlign: 'center' }}>
            {isLogin ? 'Login to Beebase Pro' : 'Register for Beebase Pro'}
          </h2>
          
          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          {/* SSO Options - Now at the top */}
          <SSOButtons 
            onError={(error) => setError(error)}
            disabled={loading}
          />
          
          <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
            <div className="form-group">
              <label>
                Email:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-control"
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label>
                Password:
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-control"
                placeholder="Enter your password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className={`btn btn-primary ${loading ? 'disabled' : ''}`}
              style={{ width: '100%' }}
            >
              {loading ? (
                <>
                  <div className="loading-spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></div>
                  Please wait...
                </>
              ) : (
                isLogin ? 'Login' : 'Register'
              )}
            </button>
          </form>
          
          <p style={{ textAlign: 'center', margin: '20px 0 0' }}>
            <span style={{ color: '#2c3e50', fontWeight: '500' }}>
              {isLogin ? "Don't have an account?" : "Already have an account?"}{' '}
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => setIsLogin(!isLogin)}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: '#3498db', 
                cursor: 'pointer', 
                textDecoration: 'underline',
                padding: '0',
                fontSize: 'inherit',
                fontWeight: '600'
              }}
            >
              {isLogin ? 'Register here' : 'Login here'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;